import { useEffect, useState } from "react";
import { Loader2, Monitor, Smartphone } from "lucide-react";
import { api } from "@/lib/api";

const List = ({ items, active, onPick }) => {
  const groups = [...new Set(items.map((i) => i.group))];
  return (
    <nav className="space-y-4 lg:max-h-[70vh] lg:overflow-y-auto pr-1" data-testid="email-preview-list">
      {groups.map((g) => (
        <div key={g}>
          <p className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold mb-1.5">{g}</p>
          {items.filter((i) => i.group === g).map((i) => (
            <button key={i.key} data-testid={`email-preview-item-${i.key}`} onClick={() => onPick(i.key)}
              className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${active === i.key ? "bg-emerald-50 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200 font-semibold" : "hover:bg-slate-100 dark:hover:bg-slate-800"}`}>
              {i.name}
            </button>
          ))}
        </div>
      ))}
    </nav>
  );
};

const Toggle = ({ on, onClick, testId, children }) => (
  <button data-testid={testId} onClick={onClick}
    className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-xs border transition-colors ${on ? "bg-slate-900 text-white border-slate-900 dark:bg-white dark:text-slate-900" : "border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800"}`}>
    {children}
  </button>
);

const Viewer = ({ d, mobile }) => (
  <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 overflow-hidden">
    <div className="px-4 py-3 border-b border-slate-200 dark:border-slate-800 text-sm space-y-0.5">
      <p data-testid="email-preview-subject"><span className="text-slate-500">Subject: </span><strong>{d.subject}</strong></p>
      <p className="text-xs text-slate-500" data-testid="email-preview-meta">From {d.from} · To: {d.audience}</p>
    </div>
    <div className="bg-slate-100 dark:bg-slate-950 p-3 flex justify-center">
      <iframe title={d.name} data-testid="email-preview-frame" srcDoc={d.html.replaceAll(d.asset_base, `${window.location.origin}/brand/`)} sandbox="allow-same-origin"
        className="bg-white border-0 rounded-md transition-[width] duration-300 h-[640px] max-w-full" style={{ width: mobile ? 375 : "100%" }} />
    </div>
  </div>
);

export const AdminEmails = () => {
  const [items, setItems] = useState(null);
  const [key, setKey] = useState("letter");
  const [branded, setBranded] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/email-previews").then((r) => setItems(r.data)); }, []);
  useEffect(() => { setD(null); api.get(`/admin/email-previews/${key}`, { params: { branded } }).then((r) => setD(r.data)); }, [key, branded]);
  if (!items) return <Loader2 className="animate-spin text-emerald-600" />;
  const brandable = items.find((i) => i.key === key)?.brandable;
  return (
    <div className="space-y-4" data-testid="admin-emails">
      <p className="text-sm text-slate-500 max-w-2xl">Every email PostalCloud sends, filled with sample details. Nothing is sent from this page.</p>
      <div className="grid lg:grid-cols-[240px_1fr] gap-6">
        <List items={items} active={key} onPick={setKey} />
        <div className="space-y-3 min-w-0">
          <div className="flex flex-wrap gap-2">
            <Toggle testId="email-preview-desktop" on={!mobile} onClick={() => setMobile(false)}><Monitor size={14} /> Desktop</Toggle>
            <Toggle testId="email-preview-mobile" on={mobile} onClick={() => setMobile(true)}><Smartphone size={14} /> Phone</Toggle>
            {brandable && <Toggle testId="email-preview-branded" on={branded} onClick={() => setBranded(!branded)}>As an organisation's branded email</Toggle>}
          </div>
          {d ? <Viewer d={d} mobile={mobile} /> : <Loader2 className="animate-spin text-emerald-600" />}
        </div>
      </div>
    </div>
  );
};
